import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/services/header.service';
import { LoginService } from 'src/app/services/login.service';
import { PersonaService } from 'src/app/services/persona.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  form: FormGroup;
  hide = true;
  validacion: boolean;

  constructor(
    private route: Router,
    private loginService: LoginService,
    private personaService: PersonaService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {

    this.form = this.fb.group({
      usuario: ['', Validators.required],
      clave1: ['', Validators.required]
    });

    this.personaService.validarFecha().subscribe(data => {
      this.validacion = data;
      
      if (data == false) {
        Swal.fire({
          icon: 'error',
          title: '¡El módulo se encuentra cerrado!',
          confirmButtonColor: '#8F141B',
          confirmButtonText: "Aceptar"
        })
      }
    })
  }



  ngAfterViewInit(): void {
    let token: string = sessionStorage.getItem(environment.tokenName);

    if (token) {
      this.route.navigate(['/validar']);
    }
  }

  onClickLogin() {

    if (this.validacion == true) {
      let usuario: string = this.form.controls['usuario'].value;
      let us = usuario.toLowerCase();
      let clave1: string = this.form.controls['clave1'].value;

      this.loginService.login(us, clave1).subscribe(res => {

        sessionStorage.setItem(environment.tokenName, res.access_token);

        this.route.navigate(['/validar']);

      }, (err: HttpErrorResponse) => {

        if (err.status == 401) {
          Swal.fire({
            icon: 'error',
            title: '¡Ha ocurrido un error!',
            text: 'Por favor intentar de nuevo. Revise las credenciales ingresadas.',
            confirmButtonColor: '#8F141B',
            confirmButtonText: "Aceptar"
          })
        }
        else {
          Swal.fire({
            icon: 'error',
            title: '¡Ha ocurrido un error!',
            text: 'Por favor intentar de nuevo. Revise las credenciales ingresadas.',
            confirmButtonColor: '#8F141B',
            confirmButtonText: "Aceptar"
          })
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: '¡El módulo se encuentra cerrado!',
        confirmButtonColor: '#8F141B',
        confirmButtonText: "Aceptar"
      })
    }

  }
}
